(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lq-poshub-landingpage-backshotv2"] && !Shopify.designMode) return;
  try {
    
  class PosHubBackshot {
    constructor(section) {
      this.section = section;
      this.hasRevealed = false;
      this.init();
    }

    init() {
      // Observer for the header (standard viewport entry)
      const headerObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting && !this.section.classList.contains('is-header-visible')) {
              this.section.classList.add('is-header-visible');
              headerObserver.disconnect();
            }
          }
        },
        {
          threshold: 0,
          rootMargin: '0px 0px -25% 0px',
        }
      );
      headerObserver.observe(this.section);

      const imageWrapper = this.section.querySelector('.lq-poshub-backshot__image-wrapper');
      if (!imageWrapper) return;

      // Observer for first image (triggered at 25% from bottom)
      const initialImageObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting && !this.section.classList.contains('is-initial-visible')) {
              this.section.classList.add('is-initial-visible');
              initialImageObserver.disconnect();
            }
          }
        },
        {
          threshold: 0,
          rootMargin: '0px 0px -15% 0px',
        }
      );
      initialImageObserver.observe(imageWrapper);

      // Observer for labeled image (triggered at 50% from bottom - center screen)
      const labeledImageObserver = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting && !this.section.classList.contains('is-labeled-visible')) {
              this.section.classList.add('is-labeled-visible');
              labeledImageObserver.disconnect();
            }
          }
        },
        {
          threshold: 0,
          rootMargin: '0px 0px -35% 0px',
        }
      );
      labeledImageObserver.observe(imageWrapper);
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.lq-poshub-backshot').forEach((section) => {
        new PosHubBackshot(section);
      });
    });
  } else {
    document.querySelectorAll('.lq-poshub-backshot').forEach((section) => {
      new PosHubBackshot(section);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lq-poshub-landingpage-herov2"] && !Shopify.designMode) return;
  try {
    
  class PosHubHeroV2 {
    constructor(section) {
      this.section = section;
      this.enableAnimations = section.dataset.enableAnimations === 'true';

      if (this.enableAnimations) {
        this.init();
      } else {
        // Show content immediately if animations disabled
        this.section.classList.add('is-loaded');
      }
    }

    init() {
      // Add loaded class after a brief delay to ensure CSS is applied
      requestAnimationFrame(() => {
        setTimeout(() => {
          this.section.classList.add('is-loaded');
        }, 100);
      });
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.lq-poshub-herov2').forEach((section) => {
        new PosHubHeroV2(section);
      });
    });
  } else {
    document.querySelectorAll('.lq-poshub-herov2').forEach((section) => {
      new PosHubHeroV2(section);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lq_poshub_three-up"] && !Shopify.designMode) return;
  try {
    
  class PosHubThreeUp {
    constructor(section) {
      this.section = section;
      this.video = section.querySelector('.lq-poshub-three-up__video');
      this.videoWrapper = section.querySelector('.lq-poshub-three-up__video-wrapper');
      this.videoPlayDelay = parseInt(section.dataset.videoPlayDelay) || 0;
      this.hasRevealed = false;
      this.init();
    }

    init() {
      // Determine what element to observe and what rootMargin to use
      // If video exists, trigger when it hits middle of viewport (-50% bottom margin)
      // Otherwise fallback to section trigger
      const target = this.videoWrapper || this.section;
      const rootMargin = this.videoWrapper ? '0px 0px -50% 0px' : '0px';

      // Use IntersectionObserver to detect when section enters viewport
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting && !this.hasRevealed) {
              this.hasRevealed = true;
              this.triggerReveal();
              observer.disconnect();
            }
          }
        },
        {
          threshold: 0,
          rootMargin: rootMargin,
        }
      );

      observer.observe(target);

      // Fix for mobile: Force video to load first frame so it's visible before playing
      if (this.video) {
        this.video
          .play()
          .then(() => {
            // Only pause if we haven't started the reveal sequence yet (prevents race condition)
            if (!this.hasRevealed) {
              this.video.pause();
              this.video.currentTime = 0.001;
            }
          })
          .catch((error) => {
            // Autoplay prevented or aborted - expected in some cases
          });
      }
    }

    triggerReveal() {
      // Add revealed class to trigger CSS animations for columns
      this.section.classList.add('is-revealed');

      // Start video playback after delay
      if (this.video) {
        setTimeout(() => {
          this.video.play().catch((error) => {
            console.log('Video autoplay prevented:', error);
          });
        }, this.videoPlayDelay);
      }
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('.lq-poshub-three-up').forEach((section) => {
        new PosHubThreeUp(section);
      });
    });
  } else {
    document.querySelectorAll('.lq-poshub-three-up').forEach((section) => {
      new PosHubThreeUp(section);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
